import React from 'react';
import { motion } from 'framer-motion';
import Counter from './Counter';

const WhyChooseUs = () => {
  const stats = [
    { label: 'Our Staff', value: 10, suffix: '+' },
    { label: 'Our Clients', value: 20, suffix: '+' },
    { label: 'Completed Projects', value: 30, suffix: '+' },
    { label: 'Running Projects', value: 40, suffix: '+' },
  ];

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-cyan/5 rounded-full blur-[150px] -z-10 translate-x-1/3 -translate-y-1/3"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-6">
              Why <span className="text-cyan">Choose Us?</span>
            </h2>
            <p className="text-slate-400 text-lg leading-relaxed mb-8">
              At <span className="text-white font-semibold">Vitrotechworld</span>, innovation is at the heart of everything we do. We don't just build technology; we engineer solutions that define tomorrow. With deep expertise across AI, Electrification, and Autonomous Systems, we provide our clients with cutting-edge tools to stay ahead of the curve. Our commitment to quality, sustainable practices, and continuous R&D ensures that every product we deliver isn't just functional—it's visionary.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-charcoal/50 border border-cyan/10 p-8 rounded-2xl glow-border text-center backdrop-blur-sm"
              >
                <div className="text-4xl sm:text-5xl font-heading font-bold text-white mb-2 flex justify-center items-baseline">
                  <span className="text-cyan text-glow">
                    <Counter end={stat.value} />
                  </span>
                  <span className="text-2xl text-neon ml-1">{stat.suffix}</span>
                </div>
                <p className="text-slate-400 font-medium tracking-wide uppercase text-sm">{stat.label}</p>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;